import { Alert, Icons } from '@cast/design-system';

import { Cluster } from 'types/cluster';

import { isAKSCluster } from '@cast/shared-cluster-context-data-access';

type Props = {
  cluster: Cluster;
  includeAutoscaler: boolean;
};

export const LongAksOnboardingAlert = ({
  cluster,
  includeAutoscaler,
}: Props) => {
  if (!isAKSCluster(cluster) || !includeAutoscaler) {
    return null;
  }

  return (
    <Alert
      size="sm"
      sx={{ mt: 8 }}
      color="advisory"
      testId="long-aks-onboarding-alert"
      title="It might take up to 15 minutes to complete the setup."
      icon={<Icons.WarningCircle />}
    >
      In the meantime, you can continue to explore the product.
    </Alert>
  );
};
